import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap-5';

import { showSaveSearchModal } from '../../store/actions/ui';

const SaveSearchButton = ({ showSaveSearchModal }) => (
  <Button
    className="rounded"
    variant="secondary"
    onClick={() => showSaveSearchModal(true)}
  >
    Save Search
  </Button>
);

SaveSearchButton.propTypes = {
  showSaveSearchModal: PropTypes.func.isRequired
};

export default connect(null, { showSaveSearchModal })(SaveSearchButton);
